import React, { useState } from 'react';
import DefaultFeedback from '../../utils/feedback/defaultFeedback';

const Correct = ({
	choices,
	correctAnswer,
	imgChoices,
	defaultFeedback,
	index,
}) => {
	const [showMore, setShowMore] = useState(false);
	let moreChoices = '';
	if (!!choices) {
		if (!!choices && Object.keys(choices).length > 0) {
			moreChoices = Object.keys(choices).map(function (choice) {
				if (choices[choice] === '' || choices[choice] === correctAnswer) {
					return false;
				}
				let TxtImgChoice = choices[choice];
				if (imgChoices[choice] !== '' && imgChoices[choice] !== 'None') {
					TxtImgChoice = <img src={imgChoices[choice]} alt="" />;
				}

				return <li key={`more_${choice}`}>{TxtImgChoice}</li>;
			});
		}
	}

	return (
		<span>
			<ul className="no-mouse-events">
				<li className="correct-answer ">{correctAnswer}</li>
				{!!defaultFeedback && <DefaultFeedback defaultFeedback={defaultFeedback} />}
			</ul>

			{showMore && (
				<div>
					<ul>{moreChoices}</ul>
				</div>
			)}

			{!moreChoices.every((x) => !x) && (
				<button
					onClick={() => setShowMore((x) => !x)}
					className="btn btn-xs btn-info mar-rgt mar-btm pull-right"
				>
					{showMore ? 'View less options' : 'View all options'}
				</button>
			)}
		</span>
	);
};

export default Correct;
